import React from "react";
import PropTypes from "prop-types";

import { HideOnMobile } from "@/components/atoms/HideOnMobile/styles";
import { Title } from "@/components/atoms/Typography/styles";
import { ReactComponent as ArrowIcon } from "@/assets/images/arrow.svg";

function ReturnButton({ handleClick, title }) {
  return (
    <button
      className="flex items-center gap-2 pl-8 pb-3"
      type="button"
      onClick={handleClick}
    >
      <ArrowIcon className="w-3" />
      <HideOnMobile>
        <Title className="underline !text-sm">{title}</Title>
      </HideOnMobile>
    </button>
  );
}

ReturnButton.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string,
};

export default ReturnButton;
